<template>
  <div class="auth-form">
    <h3 class="auth-title">
      <button class="btn" type="button" @click="back()" :disabled="isSending">
        <span class="material-icons-outlined">arrow_back</span>
      </button>
      Verificar conta
    </h3>
    <div class="two-factor-loader p-4" v-if="requestingCode">
      <div class="qt-loader"></div>
    </div>
    <template v-else>
      <div class="two-factor-image" v-if="!registeredCode && preferredTwoFactor == 'qrcode'">
        <p>
          Para configurar o duplo-fator de segurança (2FA) use o aplicativo de preferência
          como Google Authenticator (veja os links abaixo), você pode registrar via QRCode
          ou com o código logo abaixo
        </p>
        <div class="qr-code mb-2"><img :src="imageCode" /></div>
        <p class="m-3">
          Baixe o aplicativo em:
        </p>
        <div class="row">
          <div class="col-12 col-md-6">
            <a
              class="btn-store"
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2">
              <div class="pr-2">
                <svg height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 511.999 511.999" xml:space="preserve">
                <g>
                  <path style="fill:#32BBFF;" d="M382.369,175.623C322.891,142.356,227.427,88.937,79.355,6.028
                    C69.372-0.565,57.886-1.429,47.962,1.93l254.05,254.05L382.369,175.623z"/>
                  <path style="fill:#32BBFF;" d="M47.962,1.93c-1.86,0.63-3.67,1.39-5.401,2.308C31.602,10.166,23.549,21.573,23.549,36v439.96
                    c0,14.427,8.052,25.834,19.012,31.761c1.728,0.917,3.537,1.68,5.395,2.314L302.012,255.98L47.962,1.93z"/>
                  <path style="fill:#32BBFF;" d="M302.012,255.98L47.956,510.035c9.927,3.384,21.413,2.586,31.399-4.103
                    c143.598-80.41,237.986-133.196,298.152-166.746c1.675-0.941,3.316-1.861,4.938-2.772L302.012,255.98z"/>
                </g>
                <path style="fill:#2C9FD9;" d="M23.549,255.98v219.98c0,14.427,8.052,25.834,19.012,31.761c1.728,0.917,3.537,1.68,5.395,2.314
                  L302.012,255.98H23.549z"/>
                <path style="fill:#29CC5E;" d="M79.355,6.028C67.5-1.8,53.52-1.577,42.561,4.239l255.595,255.596l84.212-84.212
                  C322.891,142.356,227.427,88.937,79.355,6.028z"/>
                <path style="fill:#D93F21;" d="M298.158,252.126L42.561,507.721c10.96,5.815,24.939,6.151,36.794-1.789
                  c143.598-80.41,237.986-133.196,298.152-166.746c1.675-0.941,3.316-1.861,4.938-2.772L298.158,252.126z"/>
                <path style="fill:#FFD500;" d="M488.45,255.98c0-12.19-6.151-24.492-18.342-31.314c0,0-22.799-12.721-92.682-51.809l-83.123,83.123
                  l83.204,83.205c69.116-38.807,92.6-51.892,92.6-51.892C482.299,280.472,488.45,268.17,488.45,255.98z"/>
                <path style="fill:#FFAA00;" d="M470.108,287.294c12.191-6.822,18.342-19.124,18.342-31.314H294.303l83.204,83.205
                  C446.624,300.379,470.108,287.294,470.108,287.294z"/>
                </svg>
              </div>
              <div class="text">
                <span>Obter no</span>
                Google Play
              </div>
            </a>
          </div>
          <div class="col-12 col-md-6">
            <a
              class="btn-store"
              target="_blank"
              href="https://apps.apple.com/br/app/google-authenticator/id388497605">
              <div class="pr-2">
                <svg fill="#ffffff" version="1.1" xmlns="http://www.w3.org/2000/svg" height="28px" viewBox="0 0 512 512">
                <path d="M248.644,123.476c-5.45-29.71,8.598-60.285,25.516-80.89
                c18.645-22.735,50.642-40.17,77.986-42.086c4.619,31.149-8.093,61.498-24.826,82.965
                C309.37,106.527,278.508,124.411,248.644,123.476z M409.034,231.131c8.461-23.606,25.223-44.845,51.227-59.175
                c-26.278-32.792-63.173-51.83-97.99-51.83c-46.065,0-65.542,21.947-97.538,21.947c-32.96,0-57.965-21.947-97.866-21.947
                c-39.127,0-80.776,23.848-107.19,64.577c-9.712,15.055-16.291,33.758-19.879,54.59c-9.956,58.439,4.916,134.557,49.279,202.144
                c21.57,32.796,50.321,69.737,87.881,70.059c33.459,0.327,42.951-21.392,88.246-21.616c45.362-0.258,53.959,21.841,87.372,21.522
                c37.571-0.317,67.906-41.199,89.476-73.991c15.359-23.532,21.167-35.418,33.11-62.023
                C414.435,352.487,389.459,285.571,409.034,231.131z" />
                </svg>
              </div>
              <div class="text">
                <span>Obter no</span>
                Apple Store
              </div>
            </a>
          </div>
        </div>
      </div>
      <div v-if="preferredTwoFactor == 'email'">
        <p>Um Email com o seu código de segurança foi enviado para <b>{{this.$store.state.auth.user.email}}</b>, por favor verifique sua caixa de entrada ou spam.</p>
        <p class="font-italic">Não recebeu o email? <a href="javascript:void(0)" @click="sendEmail()">Reenviar</a></p>
      </div>
      <hr v-if="!registeredCode" />
      <div class="form-group two-factor">
        <label for="startCode">
          <template v-if="registeredCode">
            Digite o código {{ preferredTwoFactor == 'qrcode' ? 'fornecido pelo aplicativo' : 'Enviado para o seu email' }}
          </template>
          <template v-else>
            Após configurar o aplicativo digite o código fornecido por ele
          </template>
        </label>
        <div class="two-factor d-flex justify-content-between gap-3 mb-2">
          <div class="part">
            <input
              id="startCode"
              type="text"
              maxlength="1"
              v-model="code[0]"
              placeholder=" "
              autocomplete="off"
              ref="firstCodeChar"
              @paste="inputFromClipboard"
              @keyup="(e) => nextInput(0, e)"
              @focus="(e) => e.target.select()" />
          </div>
          <div class="part" v-for="(_, index) in new Array(5)" :key="index">
            <input
              type="text"
              maxlength="1"
              placeholder=" "
              autocomplete="off"
              ref="codeChars"
              v-model="code[index + 1]"
              @keyup="(e) => nextInput(index + 1, e)"
              @focus="(e) => e.target.select()" />
          </div>
        </div>
        <template v-if="!requestingCode">
          <button
            type="button"
            class="btn btn-yup-purple btn-block"
            :class="{ 'qt-loader qt-loader-mini qt-loader-right': isSending }"
            :disabled="isSending"
            @click="checkCode()">
            verificar
          </button>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from '@/plugins/axios';

export default {
  name: 'TwoFactor',
  components: {
  },
  data() {
    return {
      isSending: false,
      receivingSmsTime: null,
      receivingSmsCurrent: null,
      receivingSmsInterval: 0,
      show: false,
      code: ['', '', '', '', '', ''],
      requestingCode: true,
      registeredCode: true,
      imageCode: null,
      smsCode: false,
      manualCode: '',
      preferredTwoFactor: '',
    };
  },
  computed: {
    isMainWhitelabel() {
      return this.$store.state.admin.whitelabel.is_main;
    },
    getPreferredTwoFactor() {
      return this.$store.state.auth.preferredTwoFactor;
    },
  },
  created() {
    this.$store.dispatch('auth/getPreferredTwoFactor').then((error) => {
      this.preferredTwoFactor = this.$store.state.auth.preferred_tfa;
      if (this.preferredTwoFactor === 'email') {
        this.sendEmail();
      }
    }).catch((error) => {
      // If any error getting preferred tfa, back to login.
      this.back();
      this.$toast.show({
        title: 'Erro',
        content: 'Token expirado, faça login novamente.',
        type: 'danger',
      });
    });
    window.addEventListener('beforeunload', this.back); // Prevents user to reload the page (F5) and avoid problem with jwt token decodification on previous login.
  },
  mounted() {
    this.requestRegisterCode();
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.back); // Remove global listener to avoid the "back()" method behavior on other pages.
  },
  methods: {
    back() {
      console.log({ receivingSmsInterval: this.receivingSmsInterval });

      clearInterval(this.receivingSmsInterval);

      this.$store.dispatch('auth/logout').then(() => {
        this.$router.replace('/login');
      });
    },
    sendEmail() {
      axios().post('2fa/send-email').then((response) => {
        this.$toast.show({
          title: 'Email enviado',
          content: response.data.message,
          type: 'success',
        });
      }).catch((error) => {
        this.$toast.show({
          title: 'Erro',
          content: error.response.data.error,
          type: 'danger',
        });
      });
    },
    checkCode() {
      if (this.isSending) return;

      const otp = this.code.join('');
      let url = '2fa/verify';

      if (otp.length !== 6) return;

      this.isSending = true;

      this.preferredTwoFactor === 'qrcode' ? url = '2fa/verify' : url = '2fa/verify-email';

      axios().post(url, { otp }).then((response) => {
        localStorage.setItem('yup_chat_tfa', JSON.stringify(this.$store.state?.auth?.token));

        if (response.data?.success) {
          setTimeout(() => {
            clearInterval(this.receivingSmsInterval);

            this.$router.push('/');
            this.isSending = false;
          }, 500);
        } else {
          this.$toast.show({
            title: 'Erro',
            content: 'Erro inesperado',
            type: 'danger',
          });
        }
      }).catch((error) => {
        this.isSending = false;

        const status = error?.response?.status;

        if (status === 403) {
          error = 'Código invalido';
        } else if (status) {
          error = error.response.data;
        } else {
          error = `${error}`;
        }

        this.$toast.show({
          title: 'Erro',
          content: error,
          type: 'danger',
        });
      });
    },
    requestRegisterCode() {
      this.requestingCode = true;

      localStorage.setItem('yup_chat_tfa', '');

      axios().get('2fa/qrcode').then(async (response) => {
        this.requestingCode = false;

        const resp = response.data;
        this.registeredCode = resp.registered;

        if (!this.registeredCode) { //
          await axios().post('2fa/enable').then((response) => {
            console.log('response ENABLE', response);
            this.imageCode = response.data.qrcode;
          });
        }

        this.$refs?.firstCodeChar?.focus();
      }, (error) => {
        const code = error?.response?.status;

        let message = error?.response?.data?.error ?? error?.response?.data;

        if (!message && code) message = `Erro ${code}`;

        if (!message) message = `${error}`;

        this.$toast.show({
          type: 'danger',
          title: 'Autenticação',
          content: `${message}`,
        });

        if (message.indexOf('token is expired') !== -1) {
          localStorage.setItem('yup_chat_tfa', '');

          clearInterval(this.receivingSmsInterval);

          this.$router.replace({ name: 'AuthIntro' });
        }
      });
    },
    inputFromClipboard(event) {
      event.preventDefault();

      const source = event.clipboardData.getData('text/plain');

      if (source) {
        this.code = source.substring(0, 6).replace(/\D+/g, '').split('');
      }
    },
    nextInput(current, event) {
      const key = event.key;

      if (key === 'Backspace') {
        current -= 1;
      } else if (key >= 0 && key <= 9) {
        current += 1;
      } else if (key === 'Enter' && current === 5) {
        this.checkCode();
        return;
      } else {
        return;
      }

      if (current === -1) return;

      let next;

      if (current === 0) {
        next = this.$refs?.firstCodeChar;
      } else {
        next = this.$refs.codeChars?.[current - 1];
      }

      if (next) {
        next.focus();
        next.select();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.two-factor, .two-factor-loader, .two-factor-image {
  max-width: 410px;
}

.btn-store {
  margin-bottom: .4rem;
  border-radius: .32rem;
  background-color: #000;
  height: 52px;
  width: 100%;
  font-size: 1rem;
  font-weight: bold;
  font-family: "Lucida Grande", sans-serif;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  & > * {
    pointer-events: none;
  }

  & > div > svg {
    width: 28px;
  }

  .text {
    text-align: left;

    span {
      display: block;
      font-size: 65%;
      font-weight: normal;
    }
  }
}

.two-factor {
  .btn-sms {
    border: thin solid #ccc;
    padding: 4px 14px;
    font-size: .72rem;
    border-radius: 20px;
    height: auto !important;
  }

  .to-app {
    background-color: transparent;
    padding-right: 0;
    padding-left: 0;
    color: var(--clr-yup-purple);
  }

  .part {
    width: 14%;

    & > input {
      border-radius: .3rem;
      border: thin solid #ccc;
      outline: 0 solid #752DE6;
      width: 100%;
      padding: .62rem 0;
      transition: .2s all ease;
      text-align: center;

      &:not(:placeholder-shown) {
        border-color: transparent;
        outline-width: .14rem;
      }
    }
  }
}

.two-factor-loader {
  .qt-loader {
    width: 100%;
    height: 150px;

    &::before {
      border-color: #000;
      border-left-color: transparent;
      border-bottom-color: transparent;
      left: 50% !important;
      top: 50% !important;
      margin: 0 !important;
      transform: translate(-50%, -50%);
    }
  }
}

.two-factor-image {
  text-align: center;
}

h1 {
  font-weight: bold;
  margin-bottom: 30px;
  text-align: center;
}

.eye_icon {
  color: #bfc5cb;
}

.btn {
  margin: 0.5em 0;
}

.register {
  border-color: #0e1421 !important;
  color: #0e1421;
}

.checkbox {
  font-weight: 400;
  font-size: 14px;
  color: #752de6;
  margin-bottom: 10px;
}

.form-group {
  label {
    color: var(--foreground);
    font-size: 16px;
    margin-bottom: 20px;
  }
  input:-ms-input-placeholder {
    text-transform: lowercase !important;
  }
  input::-webkit-input-placeholder {
    text-transform: lowercase !important;
  }
  input::placeholder {
    text-transform: lowercase !important;
  }

  #inputPassword {
    border-right-color: transparent;
    border-right-width: 0;
  }

  .eyes_btn {
    background-color: var(--form-input);
    border: 1px solid var(--form-border);
    border-left-color: transparent;
    border-radius: 0.25rem;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
.darkmode .rebranding .form-control {
  border-right-color: transparent !important;
}
.darkmode .form-group .eyes_btn {
  background-color: var(--form-input);
  border-color: var(--form-border);
  border-left-color: transparent;
}
</style>
